import { createSelector } from "@reduxjs/toolkit";
import moment from "moment-timezone";

export const SecondMarketSelector = {
  state: (state) => state.secondMarket,
  setting: (state) => SecondMarketSelector.state(state).setting,
  loading: (state) => SecondMarketSelector.state(state).loading,
  productOfferingList: (state) => SecondMarketSelector.state(state).productOfferingList ?? [],
  productOfferingDetail: (state) => SecondMarketSelector.state(state).productOfferingDetail,
  activeTabKey: (state) => SecondMarketSelector.state(state).activeTabKey,
  settlementDateList: (state) => SecondMarketSelector.state(state).settlementDateList,
  settlementDate: createSelector(
    [(state) => SecondMarketSelector.state(state).settlementDateList],
    (settlementList) =>
    settlementList?.map((settlementDetail) => (
      {
        label: `${settlementDetail.settlementDate}`,
        value: moment(settlementDetail.settlementDate),
      }
      ))
  ),
  secondMarketDetail: (state) => SecondMarketSelector.state(state).secondMarketDetail,
  refOtp: (state) => SecondMarketSelector.state(state).secondMarketDetail.refOtp,
  sendFirstOTP: (state) => SecondMarketSelector.state(state).sendFirstOTP,
  verifyReceiveAccount: (state) => SecondMarketSelector.state(state).verifyReceiveAccount,
  customerOutstanding:(state) => SecondMarketSelector.state(state).customerOutstanding,
  customerOutstandingDetail: (state) => SecondMarketSelector.state(state).customerOutstandingDetail,
  fetchConfirmationInfoDone: (state) => SecondMarketSelector.state(state).fetchConfirmationInfoDone,
  stepPage:(state) => SecondMarketSelector.state(state).stepPage,
  unitDisplay: (state) => SecondMarketSelector.setting(state).unitDisplay,

}
